{
  "title": "Chill Touch",
  "source": "Player's Handbook",
  "levelAndSchool": "Necromancy cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S",
  "duration": "1 round",
  "description": [
    "You create a ghostly, skeletal hand in the space of a creature within range. Make a ranged spell attack against the creature to assail it with the chill of the grave. On a hit, the target takes 1d8 necrotic damage, and it can’t regain hit points until the start of your next turn. Until then, the hand clings to the target. If you hit an undead target, it also has disadvantage on attack rolls against you until the end of your next turn.",
    "At Higher Levels. This spell’s damage increases by 1d8 when you reach 5th level (2d8), 11th level (3d8), and 17th level (4d8)."
  ],
  "spellLists": ["eldritch-knight", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
